import map from "lodash/map";
import reverse from "lodash/reverse";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { useActivitiesOptions } from "PFCore/hooks/queries/activities/use_activities_options";

type UseParentActivityRolesIds = {
  parentActivityId: number | null;
};

export const useParentActivityRolesIds = ({ parentActivityId }: UseParentActivityRolesIds) =>
  // options/activities endpoint is used to guarantee up to date results
  useActivitiesOptions(
    { parentActivityId: parentActivityId!, perPage: PER_PAGE_UNPAGINATED },
    {
      enabled: !!parentActivityId,
      // API orders activities in descending (newest first) order, so we need to reverse it
      select: ({ entries }) => reverse(map(entries, "id"))
    }
  );
